import { Controller, useFormContext } from "react-hook-form"
import { UsageType, useDataUsage } from "../../utils"
import { BaseTable, Button, Checkbox, DateInput, Label, NumberInput, Select, Textarea } from "components"
import { useContext, useEffect, useState } from "react"
import moment from "moment"
import { FormDataContext } from "../../context"
import { convertNumber } from "utils"

export function FormUsage(props: { onSubmit: () => void }) {

    return (
        <section className="py-5 px-6">
            <div className="w-full flex-col flex gap-8">
                <UsageDetail onSubmit={props.onSubmit} />
            </div>
        </section>
    )
}

function UsageDetail(props: { onSubmit: () => void }) {
    const { control, formState } = useFormContext<UsageType>()
    const {dataAsset, dataUsage: data} = useContext(FormDataContext)

    const disposal = [
        {value: "1", label: "DISPOSAL"},
    ]

    const [disposalChecked, setDisposalChecked] = useState(data?.disposal);

    useEffect(() => {
        if (data?.disposal) {
            setDisposalChecked(true);
        } else {
            setDisposalChecked(false);
        }
    }, [data?.disposal]);

    return (
        <div>
            <div className="font-bold mb-4 bg-slate-400 p-2 dark:text-white rounded-sm">ASSET USAGE :</div>
            <div className="my-6 flex gap-2 items-center">
                <div>
                    <Checkbox
                        value={disposalChecked}
                        disabled={data?.disposal}
                        onChange={(e) => {
                            setDisposalChecked(e.target.checked);
                        }}
                    />
                </div>
                <div className="font-bold text-slate-500">I disposal this asset</div>
            </div>
            <div className="flex flex-col gap-2">
                <div className="flex gap-2">
                    <Label className="w-[200px]">USAGE STATUS</Label>
                    <Select
                        placeholder="Select Usage..."
                        isDisabled={disposalChecked}
                        options={disposal}
                        value={disposal.find((item) => item.value === "1")}
                        
                    />
                </div>

                <div className="flex gap-2">
                    <Label className="w-[200px]">NET BOOK VALUE</Label>
                   <div className="flex-grow">
                   <Controller
                        control={control}
                        name="net_book_value"
                        render={({ field, fieldState }) => (
                            <NumberInput
                                value={!disposalChecked ? "" : field.value ?? ""}
                                error={fieldState.error?.message}
                                disabled={disposalChecked}
                                decimalScale={2}

                            />
                        )}
                    />
                   </div>
                </div>

                <div className="flex gap-2">
                    <Label className="w-[200px]">DATE DISPOSAL</Label>
                    <div className="flex-grow">
                        <Controller
                            control={control}
                            name="date_disposal"
                            render={({ field, fieldState }) => (
                                <DateInput
                                    {...field}
                                    onChange={(date) => {field.onChange(moment(date).format("YYYY-MM-DD")); }}
                                    selected={moment(field.value).toDate()}
                                    value={moment(field.value).format("DD/MM/YYYY")}
                                    error={fieldState.error?.message}
                                    disabled={disposalChecked}
                                />
                            )}
                        />
                    </div>
                </div>

                <div className="flex gap-2">
                    <Label className="w-[200px]">MEMO</Label>
                    <div className="flex-grow">
                        <Controller
                            control={control}
                            name="memo"
                            render={({ field, fieldState }) => (
                                <Textarea
                                    {...field}
                                    value={field.value ?? ""}
                                    error={fieldState.error?.message}
                                    disabled={disposalChecked}
                                />
                            )}
                        />
                    </div>
                </div>

                {disposalChecked &&
                    <div className="mt-[60px]">
                        <TableSection data={data} assetCode={dataAsset?.asset_code} />
                    </div>
                }
            </div>

            <div className="mt-10 flex justify-end">
                <Button
                    type="button"
                    color="primary"
                    disabled={data?.disposal}
                    onClick={props.onSubmit}
                    loading={formState.isSubmitting ? "true" : undefined}
                >
                    Save
                </Button>
            </div>
        </div>
    )
}


function TableSection(props: {
    data: ReturnType<typeof useDataUsage>["data"],
    assetCode: string | undefined
}) {

    const {watch} = useFormContext<UsageType>()

    const valueDebetKredit = props.data?.disposal ? props.data?.disposal_value : watch('net_book_value')
    
    return (
        <>
            <div className="font-bold text-md mb-2">
                JOURNAL
            </div>
            <BaseTable>
                <thead>
                    <tr>
                        <th>DATE</th>
                        <th>ID</th>
                        <th>ACCOUNT</th>
                        <th>DEBET</th>
                        <th>KREDIT</th>
                    </tr>
                </thead>
                <tbody>
                     <tr>
                        <td>{props.data?.disposal_date ? moment(props.data?.disposal_date).format("DD/MM/YYYY") : moment().format("DD/MM/YYYY")}</td>
                        <td>{props.assetCode}</td>
                        <td>{`${props.data?.coa_disposal_code} - ${props.data?.coa_disposal_name}`}</td>
                        <td>{convertNumber(valueDebetKredit ?? 0).intoCurrency}</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>{props.data?.disposal_date ? moment(props.data?.disposal_date).format("DD/MM/YYYY") : moment().format("DD/MM/YYYY")}</td>
                        <td>{props.assetCode}</td>
                        <td>{`${props.data?.coa_asset_code} - ${props.data?.coa_asset_name}`}</td>
                        <td></td>
                        <td>{convertNumber(valueDebetKredit ?? 0).intoCurrency}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr className="text-right font-bold text-lg">
                        <th colSpan={3}>
                            TOTAL
                        </th>
                        <th>{convertNumber(valueDebetKredit ?? 0).intoCurrency}</th>
                        <th>{convertNumber(valueDebetKredit ?? 0).intoCurrency}</th>
                    </tr>
                </tfoot>
            </BaseTable>
        </>
    )
}
